module.exports = __webpack_public_path__ + "img/vol04_cup02_badge.a0457294.png";